import { useContext } from "react";
import { NotificationStreamContext } from "../NotificationStreamContext";
export const useNotificationsStreamContext = () => useContext(NotificationStreamContext);
//# sourceMappingURL=useNotificationStreamContext.js.map